import { $http } from '@/utils';

/**
 * @namespace Service
 * @class AppLogin
 * @exports Service/Account/AppLogin
 * @description API service for handing a signed in session over to the mobile app
 * @date 2026/08/12
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class AccountAppLogin {
	/**
	 * @static @name post
	 * @description Open an app login session, or pick up the one already running, returning its QR
	 * code and short code
	 * @param {Object} payload Pass regenerate to deliberately replace the running session
	 * @return {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post(`account/app-login`, payload);
	}
}
